/* eslint-disable react/no-danger */

import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import styles from './IconButton.css';

/**
 * renders an svg icon with button-like click
 * @param {object} props - props passed to this component
 * @returns {React.Component} an icon button
 */
const IconButton = props => {
  const {
    alt,
    className,
    'data-test-id': testId,
    hidden,
    icon,
    id,
    noMargin,
    onClick,
    rem: remSize,
    isReadonly,
    ...restProps
  } = props;

  // styling
  const classes = classnames(className, styles.wrapper, { [styles.readonly]: isReadonly });
  const style = {
    height: `${remSize}rem`,
    width: `${remSize}rem`
  };
  if (!noMargin) {
    style.margin = `${remSize / 2}rem`;
  }

  return (
    <span
      id={id}
      className={classes}
      role="presentation"
      onClick={isReadonly ? null : onClick}
      hidden={hidden}
      data-test-id={testId}
      {...restProps}
    >
      {/* TODO replace with svgr */}
      <div style={style} title={alt || undefined} dangerouslySetInnerHTML={{ __html: icon }} />
    </span>
  );
};

IconButton.propTypes = {
  alt: propTypes.string,
  className: propTypes.string,
  hidden: propTypes.bool,
  icon: propTypes.string.isRequired,
  id: propTypes.string,
  noMargin: propTypes.bool,
  onClick: propTypes.func,
  rem: propTypes.number,
  isReadonly: propTypes.bool,
  'data-test-id': propTypes.string
};

IconButton.defaultProps = {
  alt: '',
  className: '',
  hidden: false,
  id: '',
  noMargin: false,
  onClick: undefined,
  rem: 1,
  isReadonly: false,
  'data-test-id': ''
};

export default IconButton;
